"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _SanitizeConfiguration = require("./SanitizeConfiguration");

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _removeStyles = require("sanitize-text/transformers/removeStyles");

var _buildSanitizer = require("./buildSanitizer");

var _addLinkTargetAttribute = require("../transformers/addLinkTargetAttribute");

var hasImage = (0, _memoize.default)(function (text) {
  var containsImageRegex = /(<img *src="(.*)"(\s)*(\/)?>)/;
  return containsImageRegex.test(text);
});
var sanitize = (0, _memoize.default)(function (text, config) {
  var transformers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var element = _SanitizeConfiguration.secureDocument.body;

  try {
    _SanitizeConfiguration.secureDocument.domain = window.location.hostname.indexOf('qa') >= 0 ? 'hubspotqa.com' : 'hubspot.com';
  } catch (e) {// IE11 needs to have this but it throws an error in Chrome.
  }

  var div = _SanitizeConfiguration.secureDocument.createElement('div');

  if (text && text !== '') {
    element.innerHTML = text;
    var newConfig = (0, _extends2.default)({}, config);
    newConfig.transformers = [_removeStyles.removeStyles, _addLinkTargetAttribute.addLinkTargetAttribute].concat((0, _toConsumableArray2.default)(transformers)); // For specific documentation on the Sanitize.js library, config, or transformers, see: https://github.com/gbirke/Sanitize.js

    try {
      var sanitizer = (0, _buildSanitizer.buildSanitizer)(newConfig);
      var fragment = sanitizer.clean_node(element).cloneNode(true);
      div.appendChild(fragment);
    } catch (e) {
      console.error(e);
    }
  }

  var isTextContentOnly = config === _SanitizeConfiguration.config.TEXTONLY;
  return isTextContentOnly ? div.textContent : div.innerHTML;
});
var Sanitize = {
  hasImage: hasImage,
  sanitize: sanitize
};
var _default = Sanitize;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/sanitize-text/static-1.1206/js/sanitizers/Sanitize.js
// module id = 809
// module chunks = 209 210 211 212